import { useContext } from 'react';
import type { IPackageDocsContext } from './PackageDocsContext';
import PackageDocsContext from './PackageDocsContext';

export default function useDocsContext(): IPackageDocsContext {
  return useContext(PackageDocsContext);
}
